import React from "react";

import Footer from "../../components/layout/Footer";
import AboutHeader from "./components/AboutHeader";
import CompanyStorySection from "./components/CompanyStorySection";
import { Helmet } from "react-helmet";
import CompanyValuesSection from "../../components/blocks/CompanyValuesSection";
import PartnersLogoSection from "../../components/blocks/PartnersLogoSection";
import OurNumberSection from "./components/OurNumberSection";
import CTASection from "./components/CTASection";

const AboutUs = () => {
  return (
    <div>
      <Helmet>
        <title>Utiva | About Us</title>
      </Helmet>

      <AboutHeader />

      <PartnersLogoSection />

      <CompanyStorySection />

      <div className="mt-6">
        <CompanyValuesSection showImages={false} />
      </div>

      <OurNumberSection />

      <CTASection />

      <Footer />
    </div>
  );
};

export default AboutUs;
